module.exports = __webpack_public_path__ + "fde0b91cc061bcc12ed2bf996ee5bd56.svg";